import React, { useEffect } from 'react';
import { animate } from 'animejs';
import logo from '../assets/autros_logo.png';

const CustomSpinner = () => {
  useEffect(() => {

    animate('.letra', {
      keyframes: [
        { translateX: -50, opacity: 0, duration: 0 },
        { translateX: 0, opacity: 1, duration: 900 },
        { translateX: -5, rotate: -3, duration: 700 },
        { translateX: 5, rotate: 3, duration: 700 },
      ],
      easing: 'easeInOutSine',
      direction: 'alternate',
      loop: true,
      delay: (el, i) => i * 150,
    });

    const paths = document.querySelectorAll('.viento-linea') as NodeListOf<SVGPathElement>;
    paths.forEach((path, i) => {
      const length = path.getTotalLength();
      path.setAttribute('stroke-dasharray', `${length}`);
      path.setAttribute('stroke-dashoffset', `${length}`);

      animate(path, {
        strokeDashoffset: [length, 0],
        easing: 'linear',
        duration: 2500,
        delay: i * 300,
        direction: 'alternate',
        loop: true,
      });
    });
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '50px',
        position: 'relative',
      }}
    >
      {/* Molino */}
      <img
        src={logo}
        alt="Austros"
        id="aspa"
        className="w-20 animate-custom-spinner-spin"
        style={{
          zIndex: 2,
        }}
      />

      {/* Capa combinada viento + letras */}
      <div
        className="capa-viento-texto"
        style={{
          position: 'relative',
          width: '300px',
          height: '100px',
        }}
      >
        {/* Letras animadas */}
        <div
          id="texto-viento"
          style={{
            fontSize: '2.5em',
            fontWeight: 'bold',
            position: 'absolute',
            top: '-5px',
            left: '-20px',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2,
            color: '#36872b',
          }}
        >
          {['a', 'u', 's', 't', 'r', 'o', 's'].map((letra, index) => (
            <span
              key={index}
              className="letra"
              style={{
                display: 'inline-block',
                margin: '0 2px',
              }}
            >
              {letra}
            </span>
          ))}
        </div>

        {/* Líneas de viento */}
        <svg
          width="350"
          height="100"
          style={{
            position: 'absolute',
            top: 0,
            left: '-35px',
            zIndex: 1,
            pointerEvents: 'none',
          }}
        >
          {[20, 40, 60, 80].map((y, i) => (
            <path
              key={i}
              className="viento-linea"
              d={`M0 ${y} C 50 ${y - 10}, 100 ${y + 10}, 150 ${y} S 300 ${y - 10}, 300 ${y}`}
              stroke="#c6e882"
              strokeWidth="2"
              fill="none"
            />
          ))}
        </svg>
      </div>
    </div>
  );
};

export default CustomSpinner;